export default "__VITE_ASSET__nOZNo3Xr__"